import React from 'react';
import { LucideIcon } from 'lucide-react';

interface PageBannerProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  gradient?: string;
}

export const PageBanner: React.FC<PageBannerProps> = ({ 
  icon: Icon, 
  title, 
  description, 
  gradient = "from-sky-500 to-green-500" 
}) => {
  return (
    <div className={`bg-gradient-to-r ${gradient} rounded-2xl p-4 text-white`}>
      <div className="flex items-center space-x-4">
        <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
          <Icon className="w-6 h-6 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold mb-1">{title}</h1>
          {description && (
            <p className="text-sky-100">
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};